import { connect } from "react-redux";
import AgentComponent from "../../../Components/DashboardComponent/Body/AgentComponent";
const mapStateToProps = (state) => ({
   agentPresences: state.reducer.presences,
});
const mapDispatchToProps = (dispatch) => ({
});
 
export default connect(mapStateToProps, mapDispatchToProps)(AgentComponent);